module.exports = __webpack_public_path__ + "front/img/s3.b412de17.png";